import { render, staticRenderFns } from "./carrelloDatePicker.vue?vue&type=template&id=4a52c4b4&"
import script from "./carrelloDatePicker.vue.ts?vue&type=script&lang=ts&"
export * from "./carrelloDatePicker.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports